module.exports = __webpack_public_path__ + "static/img/14001013.dfd5ecae.png";